import { ChartOptions, TimeUnit } from 'chart.js';
import { format, isValid, parse } from 'date-fns';
import { tz } from '@date-fns/tz';

export function getTankLevelChartOptions({
    volumeRemainingData,
    intervalUnit,
    percentageUnit,
    secondaryMeasurementUnit,
    timeZone,
}: {
    volumeRemainingData: Record<string, number>;
    intervalUnit: TimeUnit;
    percentageUnit: string;
    secondaryMeasurementUnit: string;
    timeZone?: string;
}): Partial<ChartOptions<'line'>> {
    return {
        scales: {
            y: {
                beginAtZero: true,
                max: 100,
                min: 0,
                ticks: {
                    maxTicksLimit: 5,
                    stepSize: 5,
                    autoSkip: false,
                },
            },
        },
        plugins: {
            tooltip: {
                enabled: true,
                usePointStyle: true,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                bodyColor: 'rgba(17, 30, 44, 1)',
                bodyFont: {
                    family: 'Sora',
                    weight: 400,
                    size: 14,
                    lineHeight: '14px',
                },
                footerColor: 'rgba(113, 113, 113, 1)',
                footerFont: {
                    family: 'Sora',
                    size: 10,
                    weight: 400,
                    lineHeight: '10px',
                },
                footerAlign: 'center',
                callbacks: {
                    title() {
                        return '';
                    },
                    label(tooltipItem) {
                        const value = tooltipItem.parsed.y.toFixed(0);
                        const volumeRaw = Object.values(volumeRemainingData)[tooltipItem.dataIndex];
                        if (volumeRaw == null) {
                            return '';
                        }
                        // metres cubed to litres
                        const volume = (volumeRaw * 1000).toFixed(2);
                        return ` ${volume}${secondaryMeasurementUnit} (${value}${percentageUnit})`;
                    },
                    footer(tooltipItems) {
                        const [item] = tooltipItems;
                        if (item?.label == null) return '';

                        const parsedDate = parse(item.label, 'yyyy-MM-dd h:mm:ss a x', new Date(), {
                            in: timeZone == null ? undefined : tz(timeZone),
                        });

                        if (!isValid(parsedDate)) return '';

                        if (intervalUnit === 'hour') {
                            return format(parsedDate, 'hh:mma');
                        } else if (intervalUnit === 'day') {
                            return format(parsedDate, 'MMM d');
                        } else if (intervalUnit === 'month') {
                            return format(parsedDate, 'MMM yyyy');
                        } else if (intervalUnit === 'year') {
                            return format(parsedDate, 'MMM yyyy');
                        } else {
                            return parsedDate.toString();
                        }
                    },
                },
            },
        },
    };
}
